<template lang="html">
  <process-interview-test-container :interview="interview" @complete="complete" />
</template>

<script>
  export default {
    name: 'InterviewTestScene',

    props: {
      interview: Object
    },

    methods: {
      complete() {
        this.$emit('complete');
      }
    }
  };
</script>
